import React from "react";
import Center from "./Center";

export default function ErrorCard({
  message,
  width,
}: {
  message: Element | null;
  width?: number | undefined;
}) {
  return (
    <Center width={width}>
      <p className="mb3 error error-card tac">⚠️ {message}</p>
    </Center>
  );
}
